export default {
    ICONS: {
        ERASER: '/images/eraser-icon.svg',
        ORIENTATION: '/images/orientation-icon.svg',
        DIMENSTION: '/images/dimension-icon.svg',
        EDIT: '/images/edit-icon.svg',
        LOCK: '/images/lock.svg',
        CONFIRM: '/images/confirm-icon.svg',
        DELETE: '/images/trash.svg',
        CANCEL: '/images/cancel-icon.svg',
        ADD: '/images/add-icon.svg',
        DOWNLOAD: '/images/download-icon.svg',
        BACK: '/images/back-icon.svg',
        GOOGLE: '/images/google.svg',
        SPIRAL: '/images/google.svg',
        STAR: '/images/star-icon.svg',
        CIRCLE: '/images/circle-icon.svg',
        BACK_ROUND: '/images/back-icon-round.svg',
        CART: '/images/cart-icon.svg',
        X: '/images/x-icon.svg',
        HEART: '/images/heart-icon.svg',
        START_POS: '/images/star-pos.svg',
        STAR_NEG: '/images/star-neg.svg',
    }
}